import { render, staticRenderFns } from "./PetVitalPanel.vue?vue&type=template&id=b8b06b42&scoped=true"
import script from "./PetVitalPanel.vue?vue&type=script&lang=js"
export * from "./PetVitalPanel.vue?vue&type=script&lang=js"
import style0 from "./PetVitalPanel.vue?vue&type=style&index=0&id=b8b06b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b06b42",
  null
  
)

export default component.exports